import React from 'react';
import { Icon } from '@ui-library';
import { IconName } from '@ui-library/Icon/Icon.type';
import { MCPServerStatus } from '../../services/mcpApi';

const STATUS_META: Record<MCPServerStatus, { label: string; className: string }> = {
  unconfigured: {
    label: 'Untested',
    className: 'bg-bg-secondary border border-border-secondary text-text-secondary',
  },
  testing: {
    label: 'Testing',
    className: 'bg-utility-blue-50 border border-utility-blue-200 text-text-brand-primary',
  },
  auth_required: {
    label: 'Auth Required',
    className: 'bg-utility-warning-50 border border-utility-warning-200 text-utility-warning-700',
  },
  connected: {
    label: 'Connected',
    className: 'bg-utility-success-50 border border-utility-success-200 text-utility-success-700',
  },
  error: {
    label: 'Error',
    className: 'bg-bg-error-primary border border-border-error-subtle text-text-error-primary',
  },
};

/** Status pill — Untested · Testing · Auth Required · Connected · Error. */
export const StatusBadge: React.FC<{ status: MCPServerStatus; testing?: boolean }> = ({
  status,
  testing,
}) => {
  const meta = testing ? STATUS_META.testing : STATUS_META[status] || STATUS_META.unconfigured;
  return (
    <span
      className={`${meta.className} px-2 py-0.5 rounded-full text-bg-v2-xs font-bg-v2-medium tracking-wide whitespace-nowrap inline-flex items-center gap-1`}
    >
      {testing && <Icon name={IconName.Loading} size="xs" spin inheritColor />}
      {!testing && status === 'auth_required' && <Icon name={IconName.Lock} size="xs" inheritColor />}
      {testing ? 'Testing' : meta.label}
    </span>
  );
};

export default StatusBadge;
